var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 16.62C17.24 16.62 16.56 16.92 16.04 17.39L8.91 13.24C8.96 13.01 9 12.78 9 12.54C9 12.3 8.96 12.07 8.91 11.84L15.96 7.73004C16.5 8.23004 17.21 8.54004 18 8.54004C19.66 8.54004 21 7.20004 21 5.54004C21 3.88004 19.66 2.54004 18 2.54004C16.34 2.54004 15 3.88004 15 5.54004C15 5.78004 15.04 6.01004 15.09 6.24004L8.04 10.35C7.5 9.85004 6.79 9.54004 6 9.54004C4.34 9.54004 3 10.88 3 12.54C3 14.2 4.34 15.54 6 15.54C6.79 15.54 7.5 15.23 8.04 14.73L15.16 18.89C15.11 19.1 15.08 19.32 15.08 19.54C15.08 21.15 16.39 22.46 18 22.46C19.61 22.46 20.92 21.15 20.92 19.54C20.92 17.93 19.61 16.62 18 16.62ZM18 4.54004C18.55 4.54004 19 4.99004 19 5.54004C19 6.09004 18.55 6.54004 18 6.54004C17.45 6.54004 17 6.09004 17 5.54004C17 4.99004 17.45 4.54004 18 4.54004ZM6 13.54C5.45 13.54 5 13.09 5 12.54C5 11.99 5.45 11.54 6 11.54C6.55 11.54 7 11.99 7 12.54C7 13.09 6.55 13.54 6 13.54ZM18 20.56C17.45 20.56 17 20.11 17 19.56C17 19.01 17.45 18.56 18 18.56C18.55 18.56 19 19.01 19 19.56C19 20.11 18.55 20.56 18 20.56Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.cf362ab4e93a705a254411a8901d51d7.svg";
export { ForwardRef as ReactComponent };